/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActorActivityRecordActorUserId
 */
export interface ActorActivityRecordActorUserId {
}

/**
 * Check if a given object implements the ActorActivityRecordActorUserId interface.
 */
export function instanceOfActorActivityRecordActorUserId(value: object): value is ActorActivityRecordActorUserId {
    return true;
}

export function ActorActivityRecordActorUserIdFromJSON(json: any): ActorActivityRecordActorUserId {
    return ActorActivityRecordActorUserIdFromJSONTyped(json, false);
}

export function ActorActivityRecordActorUserIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActorActivityRecordActorUserId {
    return json;
}

export function ActorActivityRecordActorUserIdToJSON(json: any): ActorActivityRecordActorUserId {
    return ActorActivityRecordActorUserIdToJSONTyped(json, false);
}

export function ActorActivityRecordActorUserIdToJSONTyped(value?: ActorActivityRecordActorUserId | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

